import { BaseProductApi, autoAdaptChildrenAfterReplace } from '@inter-ikea-storageone/range';
import { ConnectionUtils } from '@inter-ikea-core/core';
export class BrorProductApi extends BaseProductApi {
    replaceEntityWithHierarchy(entityId, hostProductId, replaceInvalidEntities, allowedMovementOfChildrenInMilliMeter) {
        const replacePlacementResult = this.replace(entityId, hostProductId, false, allowedMovementOfChildrenInMilliMeter);
        const errors = replacePlacementResult?.replacedEntityResult.errors || [];
        const errorsExcludingStabilityErrors = errors.filter(e => e.failedRule?.id !== 'STABILITY_ZONE_VALIDATION');
        let newEntity = null;
        if (errorsExcludingStabilityErrors.length === 0 &&
            replacePlacementResult?.replacedEntityResult.placedEntity) {
            newEntity = replacePlacementResult.replacedEntityResult.placedEntity;
            // If we want to replace invalid child entities we will try to autoAdapt them to the new entity
            // In some cases e.g when changing the height of a frame, we want to remove everything that doesn't fit the frame
            const childrenWithNoFuture = replaceInvalidEntities
                ? autoAdaptChildrenAfterReplace(newEntity, replacePlacementResult, this.placementService)
                : replacePlacementResult.childrenResult
                    .filter(childPlacementResult => !childPlacementResult.valid)
                    .map(childPlacementResult => childPlacementResult);
            const entitiesToRemove = childrenWithNoFuture.filter(c => !c.valid).map(c => c.placedEntity);
            entitiesToRemove.forEach(e => {
                if (e)
                    ConnectionUtils.disconnectAndDisposeEntityAndHierarchy(e);
            });
        }
        else {
            const history = this.coreServices.coreModules.history();
            history?.undo();
            history?.discardLatestSnapshot();
        }
        return newEntity;
    }
}
//# sourceMappingURL=BrorProductApi.js.map